import { render } from "./SectionReference.vue?vue&type=template&id=a71d150e"
import script from "./SectionReference.vue?vue&type=script&lang=js"
export * from "./SectionReference.vue?vue&type=script&lang=js"

import "./SectionReference.vue?vue&type=style&index=0&id=a71d150e&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__